module.exports = __webpack_public_path__ + "media/images/vision-express-logo-5b73a054412bc903519310c78f6884a4.webp";